import {
  isTrackReference,
  useConnectionState,
} from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import { useDispatcherVideoContext } from '../DispatcherVideoContext/useDispatcherVideoContext';
import { Banner } from './Banner/Banner';
import { DispatcherControls } from './DispatcherControls/DispatcherControls';
import { StyledHUDMessages, StyledHUD } from './HUD.styles';
import { Header } from './Header/Header';
import { LoadingIndicator } from './LoadingIndicator';

interface Props {
  handleCardClosing: () => void;
  handleCallEnding: () => void;
}

export function HUD({ handleCardClosing, handleCallEnding }: Props) {
  const { callerVideoTrack, sharedCallerState } = useDispatcherVideoContext();
  const connection = useConnectionState();

  const messages = () => {
    // We're not connected to the room, yet
    if (connection !== ConnectionState.Connected) {
      return <LoadingIndicator message="Connecting..." />;
    }

    // We're connected, but the citizen is not
    if (!callerVideoTrack) {
      return <LoadingIndicator message="No citizen connected..." />;
    }

    // The citizen is connecting, but we don't have video quite yet
    if (
      !callerVideoTrack?.publication?.track &&
      !callerVideoTrack?.publication?.dimensions
    ) {
      return <LoadingIndicator message="Citizen is connecting..." />;
    }

    // The citizen is connected but is dark mode for safety
    if (sharedCallerState.isDarkMode) {
      return <Banner text="Caller screen hidden." />;
    }

    // The citizen is connected, but they've disabled their camera
    if (
      isTrackReference(callerVideoTrack) &&
      callerVideoTrack.publication?.track?.isMuted
    ) {
      return <Banner text="Caller camera is off." />;
    }
  };

  return (
    <StyledHUD>
      <Header handleCardClosing={handleCardClosing} />
      <StyledHUDMessages>{messages()}</StyledHUDMessages>
      <DispatcherControls handleCallEnding={handleCallEnding} />
    </StyledHUD>
  );
}
